import React, { FunctionComponent } from 'react'
import iconPagamentoBoleto from '../../../assets/icons/pagamentos/icon-pagamento-boletos.svg'
import { Icon } from '../styles'
import { IconsProp } from '../Icons.type'

const IconPagamentoBoleto: FunctionComponent<IconsProp> = ({ size }) => (
  <Icon src={iconPagamentoBoleto} />
)
export default IconPagamentoBoleto
